export enum EDataSynchronizerTargetType {
	Control
}
